import React, { useEffect, useState } from "react";
import api from "../../api";
import { Grid, Link, Wifi } from "react-feather";
import { DebounceInput } from "react-debounce-input";
import { ListGroup, Spinner } from "react-bootstrap";
import { ControlPosition, MapControl } from "@vis.gl/react-google-maps";

const ReaderSelector = ({
  showDefault,
  showReader,
  showMap,
  onSelect,
  getAllReaders,
  reader,
}) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchString, setSearchString] = useState("");
  const [showing, setShowing] = useState(false);
  const [current, setCurrent] = useState(null);
  const [firstLoad, setFirstLoad] = useState(false);
  const [defaultArray, setDefaultArray] = useState([]);

  const onSearch = (search) => {
    setLoading(true);
    api
      .get(`readers/positioned?page=1&limit=10000&filter=${search}`)
      .then((res) => {
        let filter = res.data;
        setData(filter);
        setLoading(false);
        if (!firstLoad && showDefault) {
          onSelect && onSelect(filter[0] || null);
          setSearchString(filter[0]?.serial || "");
          setCurrent(filter[0] || null);
        }
        if (!firstLoad) {
          getAllReaders && getAllReaders(filter);
        }
        setDefaultArray(filter);
        setFirstLoad(true);
      })
      .catch(() => setLoading(false));
  };

  const onFilter = (str) => {
    if (str.length > 0) {
      let arr = defaultArray.filter(
        (item) => item.serial.toUpperCase().indexOf(str.toUpperCase()) > -1
      );
      setData(arr);
    } else {
      setData(defaultArray);
    }
  };

  useEffect(() => {
    if (!reader) return;
    setCurrent(reader);
    setSearchString(reader.serial);
  }, [reader]);

  useEffect(() => {
    setShowing(false);
  }, [showReader]);

  useEffect(() => {
    onSearch("");
  }, []);

  return (
    <MapControl position={ControlPosition.TOP_LEFT}>
      <div
        className="d-flex justify-content-between align-items-center px-0"
        style={{
          background: "#ffffffff",
          margin: "10px",
          width: "220px",
          height: "32px",
          borderRadius: "2px",
        }}
        alt="reader selector"
      >
        <DebounceInput
          className="hashtag-input text-gray w-100 mx-0 px-1"
          style={{
            border: "1px solid #7f838e",
            borderRadius: "3px",
            fontSize: "12px",
            maxHeight: "32px",
          }}
          minLength={0}
          debounceTimeout={500}
          value={searchString}
          placeholder="Search readers"
          onClick={(e) => e.stopPropagation()}
          onFocus={(e) => {
            setShowing(true);
          }}
          onChange={(event) => {
            onFilter(event.target.value);
          }}
        />

        {loading && (
          <div className="w-100 bg-light d-flex justify-content-center p-2">
            <Spinner animation="border" />
          </div>
        )}
      </div>
      <div
        style={{ maxHeight: "500px", maxWidth: "250px" }}
        className="overflow-auto position-relative px-2"
      >
        {showing && (
          <ListGroup>
            {data &&
              data.length > 0 &&
              data.map((item, index) => (
                <ListGroup.Item
                  onClick={(event) => {
                    // console.log("CLICK");
                    event.stopPropagation();
                    // setSearchString(item.floorPlanName);
                    onSelect && onSelect(item);
                    setShowing(false);
                    setCurrent(item);
                  }}
                  key={index}
                  className={`cursor-pointer list-group-hover ${
                    current && item.id === current.id ? "bg-primary" : ""
                  }`}
                >
                  <Wifi size={14} />
                  <span className="ms-1">{item.serial}</span>
                  {item.wirepasNetworkId && !showMap && (
                    <Grid className="ms-2" size={14} />
                  )}
                  {item.wirepas && !showMap && (
                    <Link className="ms-1" size={14} />
                  )}
                </ListGroup.Item>
              ))}
          </ListGroup>
        )}
      </div>
    </MapControl>
  );
};
export default ReaderSelector;
